import { render, staticRenderFns } from "./BoardTutorials.vue?vue&type=template&id=dae16f76&scoped=true&"
import script from "./BoardTutorials.vue?vue&type=script&lang=js&"
export * from "./BoardTutorials.vue?vue&type=script&lang=js&"
import style0 from "./BoardTutorials.vue?vue&type=style&index=0&id=dae16f76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae16f76",
  null
  
)

export default component.exports